import { Component } from 'react';
import './meeting-selector.css';

class MeetingSelector extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            selectedMeeting: props.initialValue || '',
            validationError: false, // Track if there's a validation error
        };
    }

    // Public method to validate if a meeting has been selected
    validateSelection = () => {
        if (!this.state.selectedMeeting) {
            // Show validation error
            this.setState({
                validationError: true
            });
            return false;
        }
        // Clear validation error if validation passes
        if (this.state.validationError) {
            this.setState({
                validationError: false
            });
        }
        return true;
    }

    // Method that can be called to check if selection has been completed
    // This is called by parent to check if the step is completed before proceeding
    isCompleted = () => {
        return this.state.selectedMeeting !== null && this.state.selectedMeeting !== '';
    }

    // Generate time slots for meeting selection
    generateTimeSlots = () => {
        const slots = [];
        
        const today = new Date();
        const now = new Date();
        
        // French day names
        const dayNames = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        
        // Generate slots for today and next working day
        let daysProcessed = 0;
        let i = 0;
        
        while (daysProcessed < 2) {
            const date = new Date();
            date.setDate(today.getDate() + i);
            
            const dayOfWeek = date.getDay();
            const dayName = dayNames[dayOfWeek];
            
            // Skip weekends (Saturday and Sunday)
            if (dayOfWeek === 0 || dayOfWeek === 6) {
                i++;
                continue;
            }
            
            const day = date.getDate();
            const month = date.getMonth() + 1;
            
            // Determine if this is today to check for past times
            const isToday = date.toDateString() === today.toDateString();
            
            // Generate 2-hour slots from 10 to 18 (10-12, 12-14, 14-16, 16-18)
            for (let hour = 10; hour < 18; hour += 2) {
                const endTime = hour + 2;
                
                // If the 2-hour slot has completely passed, skip it
                if (isToday && endTime <= now.getHours()) {
                    continue;
                }
                
                // If we're past the start of the 2-hour slot, split it into 1-hour slots
                if (isToday && hour < now.getHours()) {
                    for (let singleHour = Math.max(hour, now.getHours()); singleHour < endTime; singleHour++) {
                        const dateStr = date.toISOString().split('T')[0];
                        slots.push({
                            value: `${dateStr}T${singleHour.toString().padStart(2, '0')}:00:00`,
                            label: `${dayName} de ${singleHour}h à ${singleHour + 1}h`
                        });
                    }
                }
                // If we're at the start of the 2-hour slot but past the start time (e.g., 10:01 for 10:00 slot)
                else if (isToday && hour === now.getHours() && now.getMinutes() > 0) {
                    for (let singleHour = hour; singleHour < endTime; singleHour++) {
                        const dateStr = date.toISOString().split('T')[0];
                        slots.push({
                            value: `${dateStr}T${singleHour.toString().padStart(2, '0')}:00:00`,
                            label: `${dayName} de ${singleHour}h à ${singleHour + 1}h`
                        });
                    }
                }
                // Otherwise, add the regular 2-hour slot if it's still fully available
                else {
                    const dateStr = date.toISOString().split('T')[0];
                    
                    slots.push({
                        value: `${dateStr}T${hour.toString().padStart(2, '0')}:00:00`,
                        label: `${dayName} de ${hour}h à ${endTime}h`
                    });
                }
            }
            
            daysProcessed++;
            i++;
        }
        
        // Add the "Quand vous voulez" option with value "open" as the last option
        slots.push({
            value: 'open',
            label: 'Quand vous voulez'
        });
        
        return slots;
    }

    // Handler for meeting slot selection
    handleMeetingSlotSelection = (selectedValue) => {
        this.setState({
            selectedMeeting: selectedValue
        }, () => {
            // Notify parent component of the change
            if (this.props.onMeetingSelection) {
                this.props.onMeetingSelection(this.state.selectedMeeting);
            }
        });
    }

    render() {
        const availableSlots = this.generateTimeSlots();
        
        return (
            <div className="question meeting-selector">
                <h3>Quand souhaitez-vous être rappelé(e) pour réduire vos factures ?</h3>
                <span>Merci de rester près de votre téléphone au jour et à l'heure convenue. Nos experts sont là pour vous aider, nous vous prions de ne pas les contraindre à vous rappeler si vous n'êtes pas disponible.</span>
                
                {this.state.validationError && (
                    <div className="validation-error" style={{color: 'red', marginTop: '10px'}}>
                        Veuillez sélectionner un créneau horaire pour continuer.
                    </div>
                )}
                
                <div className="meeting-slots-container">
                    {availableSlots.length > 0 ? (
                        availableSlots.map((slot, index) => (
                            <button
                                key={index}
                                className={`meeting-slot ${this.state.selectedMeeting === slot.value ? 'selected' : ''}`}
                                onClick={() => this.handleMeetingSlotSelection(slot.value)}
                            >
                                {slot.label}
                            </button>
                        ))
                    ) : (
                        <p className="no-available-slots">Aucun créneau disponible pour le moment. Veuillez réessayer plus tard.</p>
                    )}
                </div>
            </div>
        );
    }
}

export default MeetingSelector;